import { Entitlements } from '@protector/entities/licensing/constants';
import { selectSystemFlags } from 'core/core.reducer';
import { getLicensingStatus } from 'core/core.selectors';
import { selectCurrentUser } from 'core/services/auth/auth.reducer';
import { validatePlansAndEntitlements } from 'core/utils/functions';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useHasManagementOverviewAccess = (): boolean => {
  const licensingStatus = useSelector(getLicensingStatus);
  const user = useSelector(selectCurrentUser);
  const systemFlags = useSelector(selectSystemFlags);

  return useMemo(() => {
    const permittedByFlags =
      (systemFlags?.P40_27952_c_level_report_by_userID as string)?.includes(user?.id ?? '') ||
      !!systemFlags?.P40_27952_c_level_report_by_companyID ||
      !!systemFlags?.P40_27952_c_level_report;
    const permittedByEntitlement = validatePlansAndEntitlements(licensingStatus, null, [Entitlements.MANAGEMENT_REPORT]);
    return permittedByEntitlement || permittedByFlags;
  }, [systemFlags, user?.id, licensingStatus]);
};
